<template>
  <div>
    <UiSingleSelect
      v-model="currentCampus"
      title="CAMPUS"
      label="title"
      :select-object-without-reduce-key="true"
      :search-through-api="true"
      :options="campuses"
      :is-position-top="isMobileView"
      drop-down-container="w-full text-xxs sm:text-xs md:text-xs lg:text-sm"
      :select-box-classes="`h-9 md:h-10 ${
        isBlinking && 'shadow-purple-100 border-primary-purple-300'
      }`"
      :hide-title="isTabView"
      container-classes="min-w-[108px]"
      title-classes="pl-3 sm:pl-0 lg:text-sm sm:text-xxs text-[9px]"
      input-value-classes="text-xxs sm:text-xs md:text-xs lg:text-sm"
      :hide-un-select-icon="hideSelectedCrossIcon"
      :no-error="true"
      @search="getCampus"
      @deSelect="switchCampus(currentCampus)"
      @change="switchCampus(currentCampus)"
    />
  </div>
</template>

<script>
import UiSingleSelect from '@components/UiElements/UiSingleSelect.vue'
import { mapActions, mapState, mapGetters } from 'vuex'
import ROUTE from '@/src/constants/route-constants.js'
import { objectDeepCopy } from '@src/utils/generalUtil'
import { buildWhereQuery } from '@/src/utils/filters/index'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import FILTER_KEYS from '@src/constants/filter-constants.js'
import { useBlinkField, BLINK_KEYS } from '@src/utils/layoutUtils.js'
export default {
  components: {
    UiSingleSelect,
  },
  data() {
    return {
      ROUTE,
      currentCampus: '',
      campusBlinkField: false,
    }
  },
  computed: {
    ...mapState('layout', [
      'currentCampusScope',
      'campuses',
      'activeRole',
      'isTabView',
      'isMobileView',
      'blinkCampusTrigger',
    ]),
    hideSelectedCrossIcon() {
      return [
        TENANT_ROLES.PICKUP_PERSON,
        TENANT_ROLES.GUARDIAN,
        TENANT_ROLES.CAMPUS_ADMIN,
        TENANT_ROLES.STAFF,
        TENANT_ROLES.SECTION_STUDENT,
        TENANT_ROLES.SECTION_TEACHER,
      ].includes(this.activeRole)
    },
    isBlinking() {
      return this.getBlinkField ? this.getBlinkField() : false
    },
  },
  watch: {
    /**
     * Get Campus based settings and apply it every where when we are not on settings page
     */
    currentCampusScope: {
      immediate: true,
      handler() {
        if (this.$route.name !== 'feature-general-settings') this.getSettings()
        if (this.currentCampusScope?.id && this.stopBlinking) {
          this.stopBlinking()
        }
      },
    },
    blinkCampusTrigger() {
      if (this.getBlinkField && !this.getBlinkField()) {
        this.blinkCampusField()
      }
    },
  },

  created() {
    // Initialize generic blink field for campus
    const api = useBlinkField && useBlinkField(BLINK_KEYS.CAMPUS)
    if (api) {
      this.blinkCampusField = api.startBlink
      this.stopBlinking = api.stopBlink
      this.getBlinkField = api.getBlink
    }
    // Set up a watcher to sync the local campusBlinkField with composable state
    this.$watch(
      () => this.getBlinkField(),
      (newValue) => {
        this.campusBlinkField = newValue
      },
      { immediate: true },
    )

    if (this.currentCampusScope?.id) {
      this.currentCampus = this.currentCampusScope
    } else {
      this.setcurrentSelectedSection('')
    }
  },

  methods: {
    getCampus(query = '') {
      let payload = {
        $where: {
          ...buildWhereQuery(FILTER_KEYS.ILIKE, 'title', query),
        },
      }
      this.getCampusList(payload)
    },
    getSettings() {
      this.getFeaturesGeneralSettings().then((res) => {
        this.$store.commit('layout/SET_GENERAL_SETTINGS', objectDeepCopy(res))
      })
    },
    /**
     * GoTo Institue Level
     * @returns {void}
     * @description Function is performing following tasks:
     * - Reset the selected campus and selected class
     * - Shows the institue summary on dashboard
     * - Shows the list of campuses
     */
    goToInstitueLevel() {
      this.$store.commit('layout/SET_CURRENT_SELECTED_SECTION_SCOPE', '')
      this.$store.commit('layout/SET_CURRENT_SELECTED_CLASS_SCOPE', '')
      this.$store.commit('layout/SET_SELECTED_CAMPUSE', '')
      this.setcurrentSelectedSection('')
      this.setCurrentSelectedClass('')
      this.getCampusList()
    },

    switchCampus(campus) {
      if (this.stopBlinking) {
        this.stopBlinking()
      }
      this.setSelectedCampuse(campus)
      this.getCampusList()
    },
    ...mapActions('layout', [
      'setSelectedCampuse',
      'setcurrentSelectedSection',
      'setCurrentSelectedClass',
      'getCampusList',
    ]),
    ...mapActions('settings', ['getFeaturesGeneralSettings']),
  },
}
</script>
